<template>
  <div style="width: 1800px;">
    <canvas
      v-show="lineChartShow"
      ref="trendCanvas"
      :width="canvas.width"
      :height="canvas.height"
      class="trend-canvas"
    ></canvas>
    <table ref="trendTable" class="chart-table" style='border-collapse:collapse'>
      <thead ref="Head">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th ref="numTrendHead" colspan="8" class="border-right">号码走势</th>
          <th ref="totalHead" colspan="18" class="border-right">和值</th>
          <th colspan="12" class="border-right border-bottom">和值组合形态</th>
          <th colspan="6" class="border-bottom">号码形态</th>
        </tr>
        <tr class="title-number">
          <th class="ball-none border-bottom-header"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th class="ball-none border-bottom-header border-right"></th>
          <th class="ball-none border-bottom-header"></th>
          <th class="border-bottom-header" v-for="(total, thtindex) in lotteryTotalHead" :key="thtindex + 'totol'">
            <i class="ball-noraml">{{ total }}</i>
          </th>
          <th class="ball-none border-bottom-header border-right"></th>
          <template v-for="(totalGroup, tghIndex) in lotteryTotalGroupHead">
            <th class="ball-none border-bottom-header" :key="tghIndex + totalGroup + 'left'"></th>
            <th class="border-bottom-header" :key="tghIndex + totalGroup + 'center'">
              <i class="ball-noraml hezhixingtai">{{ totalGroup }}</i>
            </th>
            <th class="ball-none border-bottom-header border-right" :key="tghIndex + totalGroup + 'right'"></th>
          </template>
          <th v-for="(numStatus, nsindex) in lotteryNumStatusHead" :key="nsindex"
            class="border-bottom-header  border-right">
            <i class="ball-noraml haomaxingtai">{{ numStatus }}</i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-left border-right"
          :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
          v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }">
          </td>
          <td class="issue-numbers"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }">{{
            item.periodsNumber
          }}</td>
          <td class="ball-none border-right"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"></td>
          <td class="ball-none"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }">
          </td>
          <td :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"><span
              class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"></td>
          <td class="ball-none"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }">
          </td>
          <!-- 号码走势 -->
          <td
            :class="{ 'KuaiSan_OpenNo': (num === 'A' || num === 'B' || num === 'C'), 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
            v-for="(num, nindex) in opendNumTableList[index]" :key="nindex + 'num'">
            <i class="ball-noraml" :class="{ 'openNo-0': num === 'A' }" v-if="num === 'A'">{{ lotteryNumbHead[nindex]
              }}</i>
            <i class="ball-noraml" :class="{ 'openNo-0': num === 'B' }" v-else-if="num === 'B'">{{
            lotteryNumbHead[nindex]
          }}<em class="chonghao">2</em></i>
            <i class="ball-noraml" :class="{ 'openNo-0': num === 'C' }" v-else-if="num === 'C'">{{
            lotteryNumbHead[nindex]
          }}<em class="chonghao">3</em></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td class="ball-none border-right"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"></td>
          <td class="ball-none"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }">
          </td>
          <!-- 和值 -->
          <td id="smallRect"
            :class="{ 'KuaiSan': total === 'A', 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
            v-for="(total, tindex) in trendTotalTableList[index]" :key="tindex + 'total'">
            <i class="openNo ball-noraml" v-if="total === 'A'">
              {{ lotteryTrendTotalArr[index] }}
            </i>
            <i class="ball-noraml" v-else-if="missNumberShow">
              {{ total }}
            </i>
            <i class="ball-noraml" v-else>
            </i>
          </td>
          <td class="ball-none border-right"
            :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"></td>
          <!-- 和值组合形态 -->
          <template v-for="(totalGroup, tgindex) in trendTotalGroupTableList[index]">
            <td v-if="totalGroup !== 'A'" class="ball-none"
              :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
              :key="tgindex + 'left'"></td>
            <td v-if="totalGroup !== 'A'"
              :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
              :key="tgindex + 'center'">
              <i class="ball-noraml hezhixingtai" v-if="missNumberShow">{{ totalGroup }}</i>
              <i class="ball-noraml hezhixingtai" style="color:#fff;" v-else>x</i>
            </td>
            <td v-if="totalGroup !== 'A'"
              :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
              class="ball-none border-right" :key="tgindex + 'right'"></td>
            <td v-if="totalGroup === 'A'"
              :class="{ 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
              :key="tgindex + 'SPEC'" colspan="3" class="isSHow border-right">
              <i class="ball-noraml hezhixingtai">{{ totalGroupArr[index] }}</i>
            </td>
          </template>
          <!-- 号码形态 -->
          <td class="border-right"
            :class="{ 'isHmxt': numstatus === 'A' && nsindex > 2, 'isSHow': numstatus === 'A' && nsindex < 3, 'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1 }"
            v-for="(numstatus, nsindex) in trendNumStatusTableList[index]" :key="nsindex + 'numstatus'">
            <i v-if="numstatus === 'A'" class="ball-noraml haomaxingtai">{{ numStatusArr[index][nsindex] }}</i>
            <i v-else-if="missNumberShow" class="ball-noraml haomaxingtai">{{ numstatus }}</i>
            <i v-else class="ball-noraml haomaxingtai" style="color:#fff;">x</i>
          </td>
        </tr>
      </tbody>
      <tfoot v-show="statisticalShow" v-if="lotteryTrendList && lotteryTrendList.length > 0">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td>
          <td class="issue-numbers border-bottom">出现总次数</td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="index" v-for="(count, index) in openNumStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" v-for="(total, sindex) in totalStatisticaList.countArr" :key="sindex + 'total'">
            <i class="ball-noraml">{{ total }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="(totalGroup, tgindex) in totalGroupStatisticaList.countArr">
            <td class="ball-none border-bottom" :key="tgindex + 'totalGroup' + 'left'">
            </td>
            <td class="border-bottom" :key="tgindex + 'totalGroup' + 'center'">
              <i class="ball-noraml hezhixingtai">{{ totalGroup }}</i>
            </td>
            <td class="ball-none border-right border-bottom" :key="tgindex + 'totalGroup' + 'right'"></td>
          </template>
          <td class="border-right border-bottom" v-for="(numStatus, nscIndex) in numStatusStatisticaList.countArr"
            :key="nscIndex + 'numStatus'">
            <i class="ball-noraml haomaxingtai">{{ numStatus }}</i>
          </td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td>
          <td class="issue-numbers border-bottom">平均遗漏值</td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="amindex"
            v-for="(averageMiss, amindex) in openNumStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="tamindex + 'total'"
            v-for="(totalAverageMiss, tamindex) in totalStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ totalAverageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="(totalGroupAverageMiss, tgamindex) in totalGroupStatisticaList.averageMissArr">
            <td class="ball-none border-bottom" :key="tgamindex + 'totalGroupAverageMiss' + 'left'">
            </td>
            <td class="border-bottom" :key="tgamindex + 'totalGroupAverageMiss' + 'center'">
              <i class="ball-noraml hezhixingtai">{{ totalGroupAverageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom" :key="tgamindex + 'totalGroupAverageMiss' + 'right'"></td>
          </template>
          <td class="border-right border-bottom"
            v-for="(numStatusAverageMiss, nsamIndex) in numStatusStatisticaList.averageMissArr"
            :key="nsamIndex + 'numStatusAverageMiss'">
            <i class="ball-noraml haomaxingtai">{{ numStatusAverageMiss }}</i>
          </td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td>
          <td class="issue-numbers border-bottom">最大遗漏值</td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="mmindex" v-for="(maxMiss, mmindex) in openNumStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="tmmindex + 'total'"
            v-for="(totalMaxMiss, tmmindex) in totalStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ totalMaxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="(totalGroupMaxMiss, tgmindex) in totalGroupStatisticaList.maxMissArr">
            <td class="ball-none border-bottom" :key="tgmindex + 'totalGroupMaxMiss' + 'left'">
            </td>
            <td class="border-bottom" :key="tgmindex + 'totalGroupMaxMiss' + 'center'">
              <i class="ball-noraml hezhixingtai">{{ totalGroupMaxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom" :key="tgmindex + 'totalGroupMaxMiss' + 'right'"></td>
          </template>
          <td class="border-right border-bottom"
            v-for="(numStatusMaxMiss, nsmmIndex) in numStatusStatisticaList.maxMissArr"
            :key="nsmmIndex + 'numStatusMaxMiss'">
            <i class="ball-noraml haomaxingtai">{{ numStatusMaxMiss }}</i>
          </td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td>
          <td class="issue-numbers border-bottom">最大连出值</td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="mcindex"
            v-for="(maxContinuity, mcindex) in openNumStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="tmcindex + 'totalmc'"
            v-for="(totalMaxContinuity, tmcindex) in totalStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ totalMaxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <template v-for="(totalGroupMaxContinuity, tgmcindex) in totalGroupStatisticaList.maxContinuity">
            <td class="ball-none border-bottom" :key="tgmcindex + 'totalGroupMaxContinuity' + 'left'"></td>
            <td class="border-bottom" :key="tgmcindex + 'totalGroupMaxContinuity' + 'center'">
              <i class="ball-noraml hezhixingtai">{{ totalGroupMaxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom" :key="tgmcindex + 'totalGroupMaxContinuity' + 'right'">
            </td>
          </template>
          <td class="border-right border-bottom"
            v-for="(numStatusMaxContinuity, nsmcIndex) in numStatusStatisticaList.maxContinuity"
            :key="nsmcIndex + 'numStatusMaxContinuity'">
            <i class="ball-noraml haomaxingtai">{{ numStatusMaxContinuity }}</i>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
export default {
  mixins: [mix],
  methods: {
    drawCanvas() {
      let coordinateList = this.getChartCoordinate(this.trendTotalTableList);
      if (!coordinateList) {
        return;
      }
      if (!this.$refs.trendCanvas) {
        return;
      }
      const ctx = this.$refs.trendCanvas.getContext("2d");
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#f53f00";
      for (let i = 0, len = coordinateList.length; i + 1 < len; i++) {
        ctx.moveTo(coordinateList[i][0], coordinateList[i][1]);
        ctx.lineTo(coordinateList[i + 1][0], coordinateList[i + 1][1]);
      }
      ctx.stroke();
    },
    getChartCoordinate(Coordinate) {
      if (!this.$refs.drawnumbHead) return [];
      let len = Coordinate.length;
      if (len == 0) return [];
      let chartCoordinate = [];
      //获取坐标系
      //先获取表格左边不需要折线部分的宽度
      let dwidth = this.$refs.drawnumbHead.offsetWidth;
      let pwidth = this.$refs.periodsHead.offsetWidth;
      let ntwidth = this.$refs.numTrendHead.offsetWidth;
      let topCountWidth = this.$refs.Head.offsetHeight; // 上面总高度
      let leftCountWidth = dwidth + pwidth + ntwidth; // 左边总宽度
      //每个数据表格td宽度 表格td高度
      if (!document.getElementById("smallRect")) {
        return;
      }
      const tdWidth = document.getElementById("smallRect").offsetWidth;
      const tdHeight = document.getElementById("smallRect").offsetHeight;
      for (let i = 0; i < len; i++) {
        let numb = Number(this.lotteryTotalHead[Coordinate[i].indexOf("A")]);
        let index = this.lotteryTotalHead.indexOf(numb);
        let x = leftCountWidth + 5 + (tdWidth * index + (tdWidth / 2));
        let y = topCountWidth + (tdHeight * i + (tdHeight / 2));
        chartCoordinate.push([x, y]);
      }
      return chartCoordinate;
    },
  },
  mounted() {
    console.log('创建了')
    this.$nextTick((e) => {
      let tableDom = this.$refs.trendTable;
      console.log(tableDom)
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawCanvas();
        }, 0);
      });
    });
  },
  updated() {
    this.$nextTick((e) => {
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawCanvas();
        }, 0);
      });
    });
  },
  computed: {
    // 开奖和值走势列表
    trendTotalTableList() {
      return this.chartTotalList(this.lotteryTotalHead, this.lotteryTrendTotalArr) || []
    },
    // 表头和值
    lotteryTotalHead() {
      if (this.lotteryNumbTypeCode.length == 0) return [];
      return this.getLotteryTotalHeadArr(this.lotteryNumbTypeCode);
    },
    // 开奖和值统计
    totalStatisticaList() {
      return this.statistica(this.lotteryTotalHead, this.trendTotalTableList)
    },
    // 和值组合数组
    totalGroupArr() {
      if (this.lotteryNumbTypeCode.length == 0) return [];
      return this.getTotalGroupArr(this.lotteryNumbTypeCode);
    },
    // 和值组合走势列表
    trendTotalGroupTableList() {
      return this.chartTotalList(this.lotteryTotalGroupHead, this.totalGroupArr) || []
    },
    // 和值组合统计
    totalGroupStatisticaList() {
      return this.statistica(this.lotteryTotalGroupHead, this.trendTotalGroupTableList)
    },
    // 号码形态数组
    numStatusArr() {
      if (this.lotteryNumbTypeCode.length == 0) return [];
      return this.getNumStatusArr(this.lotteryNumbTypeCode)
    },
    // 号码形态走势列表
    trendNumStatusTableList() {
      return this.chartNumStatusList(this.lotteryNumStatusHead, this.numStatusArr) || []
    },
    // 号码形态统计
    numStatusStatisticaList() {
      return this.statistica(this.lotteryNumStatusHead, this.trendNumStatusTableList)
    }
  },
}
</script>

<style>
</style>